import { createContext, ReactElement, ReactNode, memo } from 'react';
import useTokenAssets, { UseTokenAssetsResult } from '@hooks/useTokenAssets';

export type TokenAssetsContextValue = UseTokenAssetsResult;

export const TokenAssetsContext = createContext<UseTokenAssetsResult>({
  data: null,
  hasError: false,
  isLoading: false,
});

interface TokenAssetProviderProps {
  children: ReactNode;
}

function TokenAssetProvider({
  children,
}: TokenAssetProviderProps): ReactElement {
  const contextValue = useTokenAssets();

  return (
    <TokenAssetsContext.Provider value={contextValue}>
      {children}
    </TokenAssetsContext.Provider>
  );
}

export default memo(TokenAssetProvider);
